import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const DeleteIconBordered = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 24 } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
      style={{ display: 'block' }}
    >
      <rect x="1.5" y="1.5" width="41" height="41" rx="7.5" stroke={color} />
      <path
        d="M7 12H10.3333H37"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6673 12.0002V35.3335C33.6673 36.2176 33.3161 37.0654 32.691 37.6905C32.0659 38.3156 31.218 38.6668 30.334 38.6668H13.6673C12.7833 38.6668 11.9354 38.3156 11.3103 37.6905C10.6852 37.0654 10.334 36.2176 10.334 35.3335V12.0002M15.334 12.0002V8.66683C15.334 7.78277 15.6852 6.93493 16.3103 6.30981C16.9354 5.68469 17.7833 5.3335 18.6673 5.3335H25.334C26.218 5.3335 27.0659 5.68469 27.691 6.30981C28.3161 6.93493 28.6673 7.78277 28.6673 8.66683V12.0002"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.666 20.3335V30.3335"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.334 20.3335V30.3335"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIconBordered;
